/*installing-turbo*/
/*global-installation*/
/*using-global-turbo-in-ci*/
/*repository-installation*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "安装",
  "description": "了解如何开始使用 Turborepo。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "使用以下命令开始使用 Turborepo："
  }, {
    "heading": "",
    "content": "¥Get started with Turborepo in a few moments using:"
  }, {
    "heading": "",
    "content": "启动存储库将包含："
  }, {
    "heading": "",
    "content": "¥The starter repository will have:"
  }, {
    "heading": "",
    "content": "两个可部署的应用"
  }, {
    "heading": "",
    "content": "¥Two deployable applications"
  }, {
    "heading": "",
    "content": "三个共享库可用于 monorepo 的其余部分"
  }, {
    "heading": "",
    "content": "¥Three shared libraries for use in the rest of the monorepo"
  }, {
    "heading": "",
    "content": "有关入门版 访问 GitHub 上基本入门指南的 README 文件 的更多详细信息。你还可以使用更符合你工具需求的 使用示例。"
  }, {
    "heading": "",
    "content": "¥For more details on the starter, visit the README for the basic starter on GitHub. You can also use an example that more closely fits your tooling interests."
  }, {
    "heading": "安装-turbo-installing-turbo",
    "content": "¥Installing turbo"
  }, {
    "heading": "安装-turbo-installing-turbo",
    "content": "turbo 既可以全局安装，也可以安装在你的代码库中。我们强烈建议你同时安装这两种方式，以便你可以利用快速、便捷的工作流程，并为在你的代码库中工作的所有开发者提供稳定的 turbo 版本。"
  }, {
    "heading": "安装-turbo-installing-turbo",
    "content": "¥turbo can be installed both globally and in your repository. We highly recommend installing both ways so you can take advantage of fast, convenient workflows and a stable version of turbo for all developers working in your repository."
  }, {
    "heading": "全局安装-global-installation",
    "content": "¥Global installation"
  }, {
    "heading": "全局安装-global-installation",
    "content": "全局安装 turbo 为你的本地工作流程带来了灵活性和速度。"
  }, {
    "heading": "全局安装-global-installation",
    "content": "¥A global install of turbo brings flexibility and speed to your local workflows."
  }, {
    "heading": "全局安装-global-installation",
    "content": "全局安装后，你可以从终端通过 turbo 运行脚本，快速运行可在存储库中使用的一次性命令。例如："
  }, {
    "heading": "全局安装-global-installation",
    "content": "¥Once installed globally, you can run your scripts through turbo from your terminal, quickly running one-off commands to use within your repository. For example:"
  }, {
    "heading": "全局安装-global-installation",
    "content": "turbo build：按照你的仓库的依赖图运行 build 脚本"
  }, {
    "heading": "全局安装-global-installation",
    "content": "¥turbo build: Run build scripts following your repository's dependency graph"
  }, {
    "heading": "全局安装-global-installation",
    "content": "turbo build --filter=docs --dry：快速打印 docs 包的 build 任务概要（无需运行）"
  }, {
    "heading": "全局安装-global-installation",
    "content": "¥turbo build --filter=docs --dry: Quickly print an outline of the build task for your docs package (without running it)"
  }, {
    "heading": "全局安装-global-installation",
    "content": "turbo generate：运行 生成器 以将新代码添加到你的仓库"
  }, {
    "heading": "全局安装-global-installation",
    "content": "¥turbo generate: Run Generators to add new code to your repository"
  }, {
    "heading": "全局安装-global-installation",
    "content": "cd apps/docs && turbo build：运行 docs 包及其依赖中的 build 脚本。更多信息请访问 自动包作用域部分。"
  }, {
    "heading": "全局安装-global-installation",
    "content": "¥cd apps/docs && turbo build: Run the build script in the docs package and its dependencies. For more, visit the Automatic Package Scoping section."
  }, {
    "heading": "全局安装-global-installation",
    "content": "turbo 是 turbo run 的别名。例如，turbo build 和 turbo run build 都将运行你的 build 任务。"
  }, {
    "heading": "全局安装-global-installation",
    "content": "¥turbo is an alias for turbo run. For example,\nturbo build and turbo run build will both run your build task."
  }, {
    "heading": "全局安装-global-installation",
    "content": "如果你之前已经安装了全局 turbo，请确保使用与现有安装相同的包管理器，以避免出现意外行为。你可以快速检查之前使用 turbo bin 的包管理器。"
  }, {
    "heading": "全局安装-global-installation",
    "content": "¥If you've installed global turbo before, make sure you use the same package\nmanager as your existing installation to avoid unexpected behaviors. You can\nquickly check which package manager you previously used with turbo\n    bin."
  }, {
    "heading": "在-ci-中使用全局-turbo-using-global-turbo-in-ci",
    "content": "¥Using global turbo in CI"
  }, {
    "heading": "在-ci-中使用全局-turbo-using-global-turbo-in-ci",
    "content": "你还可以在创建 CI 流水线时利用全局 turbo。访问 构建 CI 指南了解更多信息。"
  }, {
    "heading": "在-ci-中使用全局-turbo-using-global-turbo-in-ci",
    "content": "¥You can also take advantage of global turbo when creating your CI pipelines. Visit the Constructing CI guide for more information."
  }, {
    "heading": "仓库安装-repository-installation",
    "content": "¥Repository installation"
  }, {
    "heading": "仓库安装-repository-installation",
    "content": "在代码库中与其他开发者协作时，最好固定依赖的版本。你可以将 turbo 添加为存储库根目录中的 devDependency 来执行此操作："
  }, {
    "heading": "仓库安装-repository-installation",
    "content": "¥When collaborating with other developers in a repository, it's a good idea to pin versions of dependencies. You can do this with turbo by adding it as a devDependency in the root of your repository:"
  }, {
    "heading": "仓库安装-repository-installation",
    "content": "你可以继续使用全局安装的 turbo 来运行命令。全局 turbo 将遵循代码库的本地版本（如果存在）。"
  }, {
    "heading": "仓库安装-repository-installation",
    "content": "¥You can continue to use your global installation of turbo to run commands. Global turbo will defer to the local version of your repository if it exists."
  }, {
    "heading": "仓库安装-repository-installation",
    "content": "这让你能够充分利用这两种安装方式：轻松在终端中运行命令，同时维护固定版本，以便存储库中的所有开发者保持一致的使用。"
  }, {
    "heading": "仓库安装-repository-installation",
    "content": "¥This lets you to get the best of both installations: easily run commands in your terminal while maintaining a pinned version for consistent usage for all developers in the repository."
  }],
  "headings": [{
    "id": "安装-turbo-installing-turbo",
    "content": "安装 turbo /*installing-turbo*/"
  }, {
    "id": "全局安装-global-installation",
    "content": "全局安装 /*global-installation*/"
  }, {
    "id": "在-ci-中使用全局-turbo-using-global-turbo-in-ci",
    "content": "在 CI 中使用全局 turbo /*using-global-turbo-in-ci*/"
  }, {
    "id": "仓库安装-repository-installation",
    "content": "仓库安装 /*repository-installation*/"
  }]
};
import {Callout} from '#components/callout';
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
export const toc = [{
  depth: 2,
  url: "#安装-turbo-installing-turbo",
  title: _jsxs(_Fragment, {
    children: ["安装 ", _jsx("code", {
      children: "turbo"
    }), " "]
  })
}, {
  depth: 3,
  url: "#全局安装-global-installation",
  title: _jsx(_Fragment, {
    children: "全局安装 "
  })
}, {
  depth: 4,
  url: "#在-ci-中使用全局-turbo-using-global-turbo-in-ci",
  title: _jsxs(_Fragment, {
    children: ["在 CI 中使用全局 ", _jsx("code", {
      children: "turbo"
    }), " "]
  })
}, {
  depth: 3,
  url: "#仓库安装-repository-installation",
  title: _jsx(_Fragment, {
    children: "仓库安装 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "使用以下命令开始使用 Turborepo："
    }), "\n", _jsx(_components.p, {
      children: "¥Get started with Turborepo in a few moments using:"
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bunx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "启动存储库将包含："
    }), "\n", _jsx(_components.p, {
      children: "¥The starter repository will have:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "两个可部署的应用"
        }), "\n", _jsx(_components.p, {
          children: "¥Two deployable applications"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "三个共享库可用于 monorepo 的其余部分"
        }), "\n", _jsx(_components.p, {
          children: "¥Three shared libraries for use in the rest of the monorepo"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["有关入门版 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/tree/main/examples/basic",
        children: "访问 GitHub 上基本入门指南的 README 文件"
      }), " 的更多详细信息。你还可以使用更符合你工具需求的 ", _jsx(_components.a, {
        href: "/docs/getting-started/examples",
        children: "使用示例"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For more details on the starter, ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/tree/main/examples/basic",
        children: "visit the README for the basic starter on GitHub"
      }), ". You can also ", _jsx(_components.a, {
        href: "/docs/getting-started/examples",
        children: "use an example"
      }), " that more closely fits your tooling interests."]
    }), "\n", _jsxs(_components.h2, {
      id: "安装-turbo-installing-turbo",
      children: ["安装 ", _jsx(_components.code, {
        children: "turbo"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Installing ", _jsx(_components.code, {
        children: "turbo"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), " 既可以全局安装，也可以安装在你的代码库中。我们强烈建议你同时安装这两种方式，以便你可以利用快速、便捷的工作流程，并为在你的代码库中工作的所有开发者提供稳定的 ", _jsx(_components.code, {
        children: "turbo"
      }), " 版本。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo"
      }), " can be installed both globally ", _jsx(_components.strong, {
        children: "and"
      }), " in your repository. We highly recommend installing both ways so you can take advantage of fast, convenient workflows ", _jsx(_components.em, {
        children: "and"
      }), " a stable version of ", _jsx(_components.code, {
        children: "turbo"
      }), " for all developers working in your repository."]
    }), "\n", _jsx(_components.h3, {
      id: "全局安装-global-installation",
      children: "全局安装 "
    }), "\n", _jsx(_components.p, {
      children: "¥Global installation"
    }), "\n", _jsxs(_components.p, {
      children: ["全局安装 ", _jsx(_components.code, {
        children: "turbo"
      }), " 为你的本地工作流程带来了灵活性和速度。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A global install of ", _jsx(_components.code, {
        children: "turbo"
      }), " brings flexibility and speed to your local workflows."]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --global"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " global"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --global"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bun"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --global"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["全局安装后，你可以从终端通过 ", _jsx(_components.code, {
        children: "turbo"
      }), " 运行脚本，快速运行可在存储库中使用的一次性命令。例如："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Once installed globally, you can run your scripts through ", _jsx(_components.code, {
        children: "turbo"
      }), " from your terminal, quickly running one-off commands to use within your repository. For example:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "turbo build"
          }), "：按照你的仓库的依赖图运行 ", _jsx(_components.code, {
            children: "build"
          }), " 脚本"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "turbo build"
          }), ": Run ", _jsx(_components.code, {
            children: "build"
          }), " scripts following your repository's dependency graph"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "turbo build --filter=docs --dry"
          }), "：快速打印 ", _jsx(_components.code, {
            children: "docs"
          }), " 包的 ", _jsx(_components.code, {
            children: "build"
          }), " 任务概要（无需运行）"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "turbo build --filter=docs --dry"
          }), ": Quickly print an outline of the ", _jsx(_components.code, {
            children: "build"
          }), " task for your ", _jsx(_components.code, {
            children: "docs"
          }), " package (without running it)"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "turbo generate"
          }), "：运行 ", _jsx(_components.a, {
            href: "/docs/guides/generating-code",
            children: "生成器"
          }), " 以将新代码添加到你的仓库"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "turbo generate"
          }), ": Run ", _jsx(_components.a, {
            href: "/docs/guides/generating-code",
            children: "Generators"
          }), " to add new code to your repository"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "cd apps/docs && turbo build"
          }), "：运行 ", _jsx(_components.code, {
            children: "docs"
          }), " 包及其依赖中的 ", _jsx(_components.code, {
            children: "build"
          }), " 脚本。更多信息请访问 ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/running-tasks#automatic-package-scoping",
            children: "自动包作用域部分"
          }), "。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "cd apps/docs && turbo build"
          }), ": Run the ", _jsx(_components.code, {
            children: "build"
          }), " script in the ", _jsx(_components.code, {
            children: "docs"
          }), " package and its dependencies. For more, visit the ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/running-tasks#automatic-package-scoping",
            children: "Automatic Package Scoping section"
          }), "."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "turbo"
        }), " 是 ", _jsx(_components.a, {
          href: "/docs/reference/run",
          children: _jsx(_components.code, {
            children: "turbo run"
          })
        }), " 的别名。例如，", _jsx(_components.code, {
          children: "turbo build"
        }), " 和 ", _jsx(_components.code, {
          children: "turbo run build"
        }), " 都将运行你的 ", _jsx(_components.code, {
          children: "build"
        }), " 任务。"]
      }), _jsxs(_components.p, {
        children: ["¥", _jsx(_components.code, {
          children: "turbo"
        }), " is an alias for ", _jsx(_components.a, {
          href: "/docs/reference/run",
          children: _jsx(_components.code, {
            children: "turbo run"
          })
        }), ". For example,\n", _jsx(_components.code, {
          children: "turbo build"
        }), " and ", _jsx(_components.code, {
          children: "turbo run build"
        }), " will both run your ", _jsx(_components.code, {
          children: "build"
        }), " task."]
      })]
    }), "\n", _jsxs(Callout, {
      type: "error",
      title: "Avoid multiple global installations",
      children: [_jsxs(_components.p, {
        children: ["如果你之前已经安装了全局 ", _jsx(_components.code, {
          children: "turbo"
        }), "，请确保使用与现有安装相同的包管理器，以避免出现意外行为。你可以快速检查之前使用 ", _jsx(_components.a, {
          href: "/docs/reference/bin",
          children: _jsx(_components.code, {
            children: "turbo bin"
          })
        }), " 的包管理器。"]
      }), _jsxs(_components.p, {
        children: ["¥If you've installed global ", _jsx(_components.code, {
          children: "turbo"
        }), " before, make sure you use the same package\nmanager as your existing installation to avoid unexpected behaviors. You can\nquickly check which package manager you previously used with ", _jsx(_components.a, {
          href: "/docs/reference/bin",
          children: _jsx(_components.code, {
            children: "turbo     bin"
          })
        }), "."]
      })]
    }), "\n", _jsxs(_components.h4, {
      id: "在-ci-中使用全局-turbo-using-global-turbo-in-ci",
      children: ["在 CI 中使用全局 ", _jsx(_components.code, {
        children: "turbo"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Using global ", _jsx(_components.code, {
        children: "turbo"
      }), " in CI"]
    }), "\n", _jsxs(_components.p, {
      children: ["你还可以在创建 CI 流水线时利用全局 ", _jsx(_components.code, {
        children: "turbo"
      }), "。访问 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/constructing-ci#global-turbo-in-ci",
        children: "构建 CI"
      }), " 指南了解更多信息。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can also take advantage of global ", _jsx(_components.code, {
        children: "turbo"
      }), " when creating your CI pipelines. Visit the ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/constructing-ci#global-turbo-in-ci",
        children: "Constructing CI"
      }), " guide for more information."]
    }), "\n", _jsx(_components.h3, {
      id: "仓库安装-repository-installation",
      children: "仓库安装 "
    }), "\n", _jsx(_components.p, {
      children: "¥Repository installation"
    }), "\n", _jsxs(_components.p, {
      children: ["在代码库中与其他开发者协作时，最好固定依赖的版本。你可以将 ", _jsx(_components.code, {
        children: "turbo"
      }), " 添加为存储库根目录中的 ", _jsx(_components.code, {
        children: "devDependency"
      }), " 来执行此操作："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When collaborating with other developers in a repository, it's a good idea to pin versions of dependencies. You can do this with ", _jsx(_components.code, {
        children: "turbo"
      }), " by adding it as a ", _jsx(_components.code, {
        children: "devDependency"
      }), " in the root of your repository:"]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --save-dev"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --ignore-workspace-root-check"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --dev"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --ignore-workspace-root-check"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --save-dev"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bun"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --dev"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["你可以继续使用全局安装的 ", _jsx(_components.code, {
        children: "turbo"
      }), " 来运行命令。全局 ", _jsx(_components.code, {
        children: "turbo"
      }), " 将遵循代码库的本地版本（如果存在）。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can continue to use your global installation of ", _jsx(_components.code, {
        children: "turbo"
      }), " to run commands. Global ", _jsx(_components.code, {
        children: "turbo"
      }), " will defer to the local version of your repository if it exists."]
    }), "\n", _jsx(_components.p, {
      children: "这让你能够充分利用这两种安装方式：轻松在终端中运行命令，同时维护固定版本，以便存储库中的所有开发者保持一致的使用。"
    }), "\n", _jsx(_components.p, {
      children: "¥This lets you to get the best of both installations: easily run commands in your terminal while maintaining a pinned version for consistent usage for all developers in the repository."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
